<template>
  <div>
    <breadcrumb :routerList="[{to:'/orderXietong/bscOrderXietong',title:'经销商协同配置管理'},{title:'是否协同收入审批'}]"/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                  <h1>基本信息</h1>
                </div>
                <div class="h-pieceCon2" style="padding:0">
                  <div class="h-formLine">
                    <div class="tanBox">
                      <el-table
                              :data="tableDatahi"
                              border
                              max-height="420"
                              style="width: 94%; margin:0 auto;">
                        <el-table-column
                                type="index"
                                width="45"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="agentCode"
                                label="经销商编码"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="agentName"
                                label="经销商名称"
                                width="200"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="gscode"
                                label="公司编码"
                                width="140"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column prop="orderType" label="订单类型" min-width="180" :show-overflow-tooltip="true">
                          <template slot-scope="scope">
                            {{scope.row.orderType | dictname('xiaoshou_quyu_nwx')}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="isXietong" label="是否协同收入" min-width="120" :show-overflow-tooltip="true">
                          <template slot-scope="scope">
                            <span v-if="scope.row.isXietong ==='1'">是</span>
                            <span v-if="scope.row.isXietong ==='0'">否</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="cuname" label="创建人" min-width="120" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column
                                prop="ldate"
                                label="操作时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                width="180"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                  <div class="bannerBox2">
                    <div class="h-row h-mrt1">
                      <div class="h-rowIn">
                        <div class="h-rowBox">
                          <div class="h-rowCon">
                            <div class="h-pieceIn2">
                              <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                <h1>审核信息</h1>
                              </div>
                              <div class="h-pieceCon2 ">
                                <div class="h-formLine weekplandetail11" style="position: relative;">
                                  <el-form :inline="true" :model="freezeData">
                                    <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                                  style="width: 100%!important;">
                                      <el-input
                                              v-model="freezeData.auditMind2"
                                              placeholder="请输入审批意见">
                                      </el-input>
                                    </el-form-item>
                                  </el-form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style="text-align: center;margin-top: 0.3rem">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack"> 返回 </el-button>
                    <el-button class="h-btn h-bBtn h-bgred" @click="pass(2)" v-if="!daquflag">驳回</el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" @click="pass(1)" v-if="!daquflag">通过</el-button>

                    <el-button class="h-btn h-bBtn h-bgred" @click="daquPass(2)" v-if="daquflag">大区驳回</el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" @click="daquPass(1)" v-if="daquflag">大区通过</el-button>

                    <el-button class="h-btn h-bBtn" @click="viewpress">
                      审批跟踪
                    </el-button>
                  </div>

                  <viewhistory :visible.sync="showhistory" v-if="showhistory"
                               :id="instid"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ss from "../../../api/SystemService";
  export default {
    data(){
      return {
        freezeData:{
          auditMind2:"",
          agentCode:"",
          agentName:"",
          gscode:""
        },
        tableDatahi:[],
        refid:null,
        taskid:null,
        instid:null,
        showhistory:false,
        daquflag:false
      }
    },
    methods: {
      //加载审批详情
      loadCollabAudit(){
        let query = {
          instid:this.$route.query.instid,
          ywid:this.$route.query.ywid
        }
        ss.orderXietong.selectPage(query).then(res => {
          console.log("审批详情返回",res)
          this.tableDatahi = res.records;
        })
      },
      //获取附件refid
      getCollabFile(){
        let query = {
          agentCode:this.freezeData.agentCode
        }
        ss.orderXietong.getCollabFile(query).then(res => {
          console.log("附件返回",res);
          this.refid = res.msg.refid;
        })
      },
      //普通节点审批：1通过 2驳回
      pass(aaa){
        let query = {
          id:this.$route.query.ywid,
          taskid:this.$route.query.taskid,
          aaa:aaa,
          auditMind2:this.freezeData.auditMind2,
          agentCode: this.freezeData.agentCode,
          agentName:this.freezeData.agentName,
          gscode:this.freezeData.gscode,
          instid:this.$route.query.instid,
          ywid:this.$route.query.ywid,
        }
        ss.orderXietong.shenpiPass(query).then(res => {
          this.$msg.alerts("提交成功！", () => {
            this.$store.dispatch("searchTasktotal")
            this.$router.push({
              path: '/personal/dealCenter'
            })
          })
        })
      },
      //大区节点审批
      daquPass(aaa){
        let query = {
          taskid:this.$route.query.taskid,
          aaa:aaa,
          auditMind2:this.freezeData.auditMind2,
          agentCode: this.freezeData.agentCode,
          agentName:this.freezeData.agentName,
          gscode:this.freezeData.gscode,
          instid:this.$route.query.instid,
          ywid:this.$route.query.ywid,
        }
        ss.orderXietong.collabDaquAuditPass(query).then(res => {
          this.$msg.alerts("提交成功！", () => {
            this.$store.dispatch("searchTasktotal")
            this.$router.push({
              path: '/personal/dealCenter'
            })
          })
        })
      },
      viewpress() {
        this.showhistory = true;
      },
      goBack() {
        this.$router.push({
          path: '/agent/agentCollab'
        })
      }
    },
    created(){
      this.loadCollabAudit();
      this.taskid =  this.$route.query.taskid;
      this.instid =  this.$route.query.instid
    }
  }
</script>

<style>
  .xuanzewuliao .el-dialog__header{
    padding-top: 20px;
    padding-left: 20px;
  }
  .xuanzewuliao .el-dialog__body{
    padding: 20px;
  }
  .xuanzewuliao .el-table tbody td .cell {
    padding: 0.1rem 0.1rem !important;
  }
  .xuanzewuliao .h-formbLine .el-form-item__label{
    width: 39%;
  }
  .xuanzewuliao  .h-formbLine .el-form-item__content{
    width: 55%;
  }
  .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
    width: 55%;
  }
  .xuanzewuliao .yxline{
    padding-top: 0;
  }
  .xuanzewuliao .h-pagination{
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  .xuanzewuliao .h-rowCon{
    padding-bottom: 0rem;
  }
</style>
